export enum ErrorMessages {
	GenericError = 'Something went wrong. Please check your internet connection and try again.',
	NewsItemsNotFound = 'There are no news items available at the moment. Please try again later.',
	FlightsNoData = 'We were unable to load flight data, please try again.',
	JobsNotFound = 'There are no jobs available at the moment. Please try again later.',
	NoResults = 'There are no results for your search, please change your search input.',
	SecurityWaitTimes = 'Unable to retrieve security wait times, please wait a few minutes and try again.',
	ParkingAvailability = 'Unable to retrieve parking data',
	ParkingAvailabilityWidget = 'Unable to retrieve parking data, please wait a few minutes and try again.',
	WaitAndTryAgain = 'Please wait a few minutes and try again.',
	ShopDineRelax = 'We were not able to retrieve the data for shop & dine, please try again later.',
	FlightNoResult = 'Unable to load flight',
	RetrieveDocuments = 'Unable to retrieve documents',
}
